import { Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import LogoTextIcon from "../../assets/icons/menu_icons/logotext.svg"
import NCText from "../../shared/NCText"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useTranslation } from "react-i18next"

const FONT_FAMILY = "'DM Sans', Roboto, Helvetica, Arial, sans-serif"

const useStyles = makeStyles(() => ({
  box: {
    background: "linear-gradient(174.61deg, #1EAAC4 0%, #10658E 104.65%)"
  },
  inner: {
    width: "100%",
    maxWidth: "820px",
    margin: "0 auto",
    padding: "0 24px"
  },
  logoLink: {
    display: "inline-flex",
    lineHeight: 0
  },
  logo: {
    display: "block",
    width: "150px",
    cursor: "pointer"
  },
  navGroup: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  nav: {
    color: "white",
    padding: "0 10px",
    cursor: "pointer",
    lineHeight: 1,
    whiteSpace: "nowrap"
  },
  subHeading: {
    fontSize: "20px",
    fontFamily: FONT_FAMILY
  },
  content: {
    margin: "24px auto",
    maxWidth: "820px",
    padding: "0 24px",
    fontFamily: FONT_FAMILY,
    fontSize: "15px",
    lineHeight: 1.6,
    color: "#2d3748",
    "& h1, & h2, & h3": {
      fontFamily: FONT_FAMILY,
      fontWeight: 700,
      color: "#1a202c",
      lineHeight: 1.3
    },
    "& h1": { fontSize: "24px", margin: "24px 0 12px" },
    "& h2": {
      fontSize: "20px",
      margin: "24px 0 10px",
      paddingBottom: "6px",
      borderBottom: "1px solid #e2e8f0"
    },
    "& h3": { fontSize: "17px", margin: "18px 0 8px" },
    "& p": {
      margin: "0 0 10px"
    },
    // Collapse the empty/whitespace-only paragraphs the CMS body ships with
    "& p:empty": {
      display: "none"
    },
    "& ul, & ol": {
      paddingLeft: "24px",
      margin: "4px 0 10px"
    },
    "& li": {
      marginBottom: "4px"
    },
    "& a": {
      color: "#1EAAC4"
    },
    // The CMS body pads content with runs of <br>; suppress them
    "& br": {
      display: "none"
    },
    "& > *:first-child": {
      marginTop: 0
    }
  }
}))
const PrivacyLayout = props => {
  const nav = useNavigate()
  const cls = useStyles()
  const [searchParams] = useSearchParams()
  const showHeader = searchParams.get("header") !== "false"

  const {t} = useTranslation();

  return (
    <>
      {showHeader && (
      <Box className={cls.box} py={1.5}>
        <Box
          className={cls.inner}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <a href="https://app.noahcares.com/" className={cls.logoLink}>
            <img className={cls.logo} src={LogoTextIcon} alt="Noah Cares" />
          </a>
          <Box className={cls.navGroup}>
            <NCText className={cls.nav} onClick={() => nav("/privacy-policy")}>
              {t("login.privacy_policy")}
            </NCText>
            <NCText className={cls.nav} onClick={() => nav("/terms-conditions")}>
              {t("login.terms_conditions")}
            </NCText>
          </Box>
        </Box>
      </Box>
      )}
      {props.title && (
        <Box bgcolor="#F3FAFC" py={1.5}>
          <Box className={cls.inner} display="flex" justifyContent="center">
            <NCText className={cls.subHeading}>{props.title}</NCText>
          </Box>
        </Box>
      )}
      <div className={cls.content}>{props.children}</div>
    </>
  )
}

export default PrivacyLayout
